import { StorefrontTableCategoryDialog } from "./StorefrontTableCategoryDialog";

export const StorefrontTableCategoryDialogContainer = ({
  active,
  onDismiss,
  productId,
  setBestPricePromiseDialogActive,
}: {
  active: boolean;
  onDismiss: () => void;
  productId: number;
  setBestPricePromiseDialogActive?: (active: boolean) => void;
}) => {
  return (
    <>
      <StorefrontTableCategoryDialog
        active={active}
        onDismiss={onDismiss}
        productId={productId}
        setBestPricePromiseDialogActive={setBestPricePromiseDialogActive}
      />
    </>
  );
};
